import debugImpl from 'debug';

export const debug = debugImpl('RMI').extend('UI');
